import { render, staticRenderFns } from "./EditVenue.vue?vue&type=template&id=88dd321c&"
import script from "./EditVenue.vue?vue&type=script&lang=js&"
export * from "./EditVenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports